// extracted by mini-css-extract-plugin
export default {"wrapper":"Hr-z","response":"Ir-z","error":"Jr-z","disabled":"Kr-z","buttons":"Lr-z","feedbackQuestionSection":"Mr-z","yesNoWrapper":"Nr-z"};